import { IUserStatus } from "../../models/IUserStatus";

export class UsersStatusState {
  data: IUserStatus[] = [];
}
